export interface IDataChangeStatus {
  dataid: number;
  tripstochange: number[];
  dataauxid: number;
  prividerid?: number;
  actualpickup?: string;
  allLegs?: boolean;
}

export enum EnumStatusTrip {
  Open = 1,
  Active = 2,
  Accepted = 3,
  Pickup = 5,
  NoShow = 6,
  Cancelled = 7,
  Closed = 8,
  Rejected = 9,
  Completed = 10,
  Verify = 11,
  Billed = 12,
  Requested = 13,
  Hold = 14,
  Scheduled = 15,
  Arrived = 16
}
export const STATUSTRIP: IStatusChange[] = [
  {description: 'Scheduled', id: 15},
  {description: 'Accepted', id: 3},
  {description: 'Arrived', id: 16},
  {description: 'Cancelled', id: 7},
  {description: 'Completed', id: 10},
  {description: 'Hold', id: 14},
  {description: 'Open', id: 1},
  {description: 'Pickup', id: 5},
  {description: 'Active', id: 2},
  {description: 'Closed', id: 8},
  {description: 'Rejected', id: 9},
  {description: 'NoShow', id: 6},
  {description: 'Re-Active', id: 2},
];

export interface IStatusChange {
  description: string;
  id: number;
  active?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/core/interfaces/change-status.interface.ts